import ExistingOrderPopup from "../../../../../pages/orders/order-popup/existing-order-popup";
import React, { useEffect, useState } from "react";
import { OrderModel } from "../../../../../pages/shared/models/order/order-item.model";
import {
    getAdditionalServices,
    getCountries,
    getCurrencies,
    getProductCategories,
    getProductStores,
    getRecipientDocumentTypes,
    getShippingMethods,
    getWeightUnits
} from "../../../../../redux/slices/static-data.slice";
import { useOutletContext, useParams } from "react-router-dom";
import ordersService from "../../../../../services/orders.service";
import { OutletContext } from "../../../../../router/router";
import { useAppDispatch } from "../../../../../redux/store";
import { OrderPopupContainer } from "../../../../../pages/orders/order-popup/styled";

const CustomerOrder = () => {
    const [order, setOrder] = useState<OrderModel>();
    const [isReady, setIsReady] = useState<boolean>(false);
    const { orderId } = useParams();

    const outletContext = useOutletContext<OutletContext>();

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (orderId) {
            Promise.allSettled([
                ordersService.getOrderById(+orderId),
                dispatch(getCurrencies()),
                dispatch(getWeightUnits()),
                dispatch(getCountries()),
                dispatch(getShippingMethods()),
                dispatch(getAdditionalServices()),
                dispatch(getRecipientDocumentTypes()),
                dispatch(getProductCategories()),
                dispatch(getProductStores({})),
            ]).then(([orderResponse]) => {
                if (orderResponse.status === 'fulfilled') {
                    setOrder(orderResponse.value);
                }
                setIsReady(true)
            })
        }
    }, [])

    if (isReady && order) {
        return (
            <OrderPopupContainer>
                <ExistingOrderPopup order={order}
                    setOrder={() => void (0)}
                    orderValidationErrors={{}}
                    productValidationErrors={{}}
                    setOrderValidationErrors={() => void (0)}
                    setProductValidationErrors={() => void (0)}
                    isReadonly={true}
                    showToast={() => void (0)}
                    loadAndSetOrder={() => void (0)}
                    mainContentContainerRef={outletContext.mainContentContainerRef} />
            </OrderPopupContainer>
        )
    } else {
        return <></>
    }
};

export default CustomerOrder;
